import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, OnInit, Renderer2, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { IPaquete } from '@appNeo/core/interfaces/IPaquete';
import { ConfigTituloPaginasService } from '@appNeo/core/services/config-titulo-paginas.service';
import { AccionesDialogComponent } from '@appNeo/neoShared/components/acciones-dialog/acciones-dialog.component';
import { IBanner } from '@appNeo/neoShared/helpers/interfaces/IBanner';
import { EdicionSeccionesService } from '@appNeo/neoShared/modules/edicion-secciones/edicion-secciones.service';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'neo-cumpleanos',
  templateUrl: './cumpleanos.component.html',
  styleUrls: ['./cumpleanos.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CumpleanosComponent implements OnInit {
  precargaMeta;
  precargaTitulo;
  tituloCumpleanos: string = 'Cumpleaños';
  banner: IBanner;
  cargando: boolean = true;
  paquetes: IPaquete[] = [];
  sliderClientes = new Object();

  @ViewChild('dialogoInformacionBanner') dialogoInformacionBanner: TemplateRef<any>;
  @ViewChild('accionDialogoInformacionBanner') accionDialogoInformacionBanner: AccionesDialogComponent;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.gestionarPosicionBanner(false);
  }
  constructor(
    private element: ElementRef,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private auxiliarService: AuxiliarService,
    private configTitulo: ConfigTituloPaginasService,
    private dialog: MatDialog,
    private edicionSeccionesService: EdicionSeccionesService
  ) { }

  ngOnInit(): void {
    this.route.data.subscribe(
      response => {
        this.precargaMeta = response.precarga.precargaMeta;
        this.precargaTitulo = response.precarga.precargaTitulo;
        this.banner = response.precarga.banner;
        this.paquetes = response.precarga.paquetes;
        // if (this.banner && this.banner.activo) {
        //   this.banner = { ...this.banner, ...this.auxiliarService.obtenerContenidoPorIdioma(this.banner['idiomas']) }
        // }
        // **********************************
        // Titulo y meta
        // **********************************
        this.configTitulo.establecerTitulo('Cumpleaños', 'cumpleanos-meta', this.precargaMeta, 'meta-tit');
        this.configTitulo.establecerMeta(environment.descripcionMetaDefecto, 'cumpleanos-meta', this.precargaMeta, 'meta-des');
        this.precargaTitulo.elementos?.forEach((elemento, index) => {
          let indice = (this.precargaTitulo?.multiple) ? index : -1;
          this.tituloCumpleanos = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'txt-tit', indice);
          return;
        });
      }
    );

    // **********************************
    // SECCION CARROUSEL CUMPLEANOS
    // **********************************
    this.edicionSeccionesService.getContenidoBloquesSubseccion('cumpleanos-slider').subscribe(data => {
      data.elementos.forEach((elemento, index) => {
        let indice = (data.multiple) ? index : -1;
        this.sliderClientes['titulo'] = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'slider-tit', indice).replace(/\n/g, '<br>');
        this.sliderClientes['imagenes'] = this.mapearImagenesCarousel(this.edicionSeccionesService.getCamposEdicionItem(elemento, 'slider-img', indice));
      });
    });

    console.log('::DEBUG sliderClientes', this.sliderClientes);
  }

  mapearImagenesCarousel(imagenes: any[]) {
    let imagenesMap = [];
    imagenes.forEach(imagen => {
      if (imagen['ruta'] && imagen.temporal != 1) {
        imagenesMap.push(
          {media: {src: imagen['ruta'], alt: imagen['alt'] } }
        )
      }
    })
    return imagenesMap;
  }

  verInformacionBanner() {
    this.dialog.open(this.dialogoInformacionBanner, { panelClass: 'dialogoInformacionBanner' });
  }

  private gestionarPosicionBanner(primeraCarga: boolean) {
    let _banner: HTMLElement = this.element.nativeElement.querySelector(
      '.banner'
    );
    var referenciaFixedOffset = this.element.nativeElement.querySelector(
      '.bottom-cta'
    ).offsetTop;

    const scrollTop =
      this.document.documentElement.scrollTop ||
      this.document.body.scrollTop ||
      0;

    console.log('referenciaFixedOffset', referenciaFixedOffset);
    if (_banner) {
      if (scrollTop + window.innerHeight > referenciaFixedOffset) {
        console.log('[gestionarPosicionBanner] SCROLL BANNER fixed', scrollTop);
        this.renderer.removeClass(_banner, 'banner-fixed');
        console.log(_banner.className);
      } else {
        console.log('[gestionarPosicionBanner] SCROLL BANNER flotante', scrollTop);
        // si no hay scroll, se vuelve al estado normal
        this.renderer.addClass(_banner, 'banner-fixed');
        console.log(_banner.className);
      }
    }
  }
}
